import Vue from 'vue'
import Router from 'vue-router'

import Home from '@/views/Home'
import Checkout from '@/views/Checkout'
import Create from '@/views/home/Create'
import Transfer from '@/views/home/Transfer'
Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.NODE_ENV === 'production' ? '/cadastro' : '/',
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      component: Home,
      children: [
        {
          path: 'create',
          name: 'create',
          component: Create
        },
        {
          path: 'transfer',
          name: 'transfer',
          component: Transfer
        }
      ]
    },
    {
      path: 'checkout',
      name: 'checkout',
      component: Checkout
    }
  ]
})
